import React, { useState } from "react";
import axios from "axios";
import Utils from "../../Utils";
import Swal from "sweetalert2";
import AzureBlobUploadHelper from "../../AzureBlobUploadHelper";

const PrRequestUpload = ({ psid, prReadyIds, onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false);

  const onHandleSubmit = (e) => {
    e.preventDefault();

    // ✅ Confirm before upload
    Swal.fire({
      title: "Upload PR Files?",
      text: "Are you sure you want to upload these files?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, upload",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const highresFile = e.target.highres.files[0];
      const usageRightFile = e.target.usageright.files[0];

      setUploading(true);

      // ✅ Loader popup
      Swal.fire({
        title: "Uploading...",
        text: "Please wait while files are uploading",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      Promise.all([
        AzureBlobUploadHelper.upload({
          psid,
          purpose: "pr-highres",
          file: highresFile,
        }),
        AzureBlobUploadHelper.upload({
          psid,
          purpose: "pr-usageright",
          file: usageRightFile,
        }),
      ])
        .then(([highresUpload, usageRightUpload]) =>
          axios.post(
            Utils.apiUrl("photoshoot/pr-upload-direct"),
            {
              psid,
              photoIds: prReadyIds,
              highres_url: highresUpload.blobUrl,
              usageright_url: usageRightUpload.blobUrl,
            },
            {
              headers: {
                ...Utils.apiHeaders().headers,
              },
            },
          ),
        )
        .then((res) => {
          Swal.close();

          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: res.data.message || "PR files uploaded successfully!",
            });

            if (onUploadSuccess) {
              onUploadSuccess();
            }

            // Optional: reset form
            e.target.reset();
          } else {
            Swal.fire({
              icon: "error",
              title: "Upload Failed",
              text: res.data.message || "Upload failed",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Swal.close();

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong during upload",
          });
        })
        .finally(() => {
          setUploading(false);
        });
    });
  };

  return (
    <div className="my-4">
      <form onSubmit={onHandleSubmit} className="grid grid-cols-2 gap-6">
        <div className="flex flex-col">
          <label className="mb-2 font-medium">
            Upload High Res Images (ZIP)
          </label>
          <input type="file" name="highres" accept=".zip" required />
        </div>

        <div className="flex flex-col">
          <label className="mb-2 font-medium">
            Upload Usage Rights (PDF / DOCX)
          </label>
          <input
            type="file"
            name="usageright"
            accept=".pdf,.doc,.docx"
            required
          />
        </div>

        {/* Loader text only */}
        {uploading && (
          <div className="col-span-2 text-blue-600 text-sm font-medium">
            Uploading file, please wait…
          </div>
        )}

        <div className="col-span-2">
          <button
            type="submit"
            disabled={uploading}
            className={`px-4 py-2 bg-blue-600 text-white rounded ${uploading ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            Upload Files
          </button>
        </div>
      </form>
    </div>
  );
};

export default PrRequestUpload;
